module.exports = __webpack_public_path__ + "static/fipcpinkfloral3-c3811ef23ef8458f3acdb263439efc77.jpeg";